import * as ol from 'openlayers';
import { EmployeesDataSource } from './../../../data-management/data-sources/sources/employees-data-source';
import { ColorConfig } from './../../color-config';
import { EmployerIds } from '../../../util/app-constants';

export class MapStyles {
    public static userDataIdsToVisibility: boolean[] = [];
    public static usersDataSource: EmployeesDataSource;

    public static returnSelectedStyle = (feature: any) => {
        let s = new ol.style.Style({
            image: new ol.style.Circle({
                fill: new ol.style.Fill({
                    color: ColorConfig.selected
                }),
                stroke: new ol.style.Stroke({
                    color: ColorConfig.selected,
                    width: 1
                }),
                radius: 5
            })
        });
        return s;
    }

    // Styling
    public static returnHeatmapActiveStyle = (feature: any) => {
        let visibleStyle = new ol.style.Style({
            image: new ol.style.Circle({
                fill: new ol.style.Fill({
                    color: ColorConfig.organigramConsultantEnabled
                }),
                radius: 3
            })
        });
        let inVisibleStyle = new ol.style.Style({
            image: new ol.style.Circle({
                fill: new ol.style.Fill({
                    color: 'rgba(0,0,0,0.2)'
                }),
                radius: 2
            })
        });
        if (MapStyles.userDataIdsToVisibility[feature.getId()]) {
            return visibleStyle;
        } else {
            return inVisibleStyle;
        }
    }

    public static returnActiveStyle = (feature: any) => {
        let visibleStyle = new ol.style.Style({
            image: new ol.style.Circle({
                fill: new ol.style.Fill({
                    color: ColorConfig.organigramConsultantEnabled
                }),
                radius: 3
            })
        });
        let inVisibleStyle = new ol.style.Style({
            image: new ol.style.Circle({
                fill: new ol.style.Fill({
                    color: 'rgba(0,0,0,0)'
                }),
                radius: 1
            })
        });
        if (MapStyles.userDataIdsToVisibility[feature.getId()]) {
            return visibleStyle;
        } else {
            return inVisibleStyle;
        }
    }
}
